import api from './api'

export default (query?: Query): Promise<Company[]> => api.get({ path: '/companies', query })

export type Query = {
    noOfItems?: number
    name?: string
}

export interface Company {
    // not sure about any of those types
    id: string
    name: string
    email: string | null
    phone?: string
    description?: string
    address1?: string
    address2?: string
    chargingCount: number
    comment?: string
    contactPerson?: string
    kWhPrice?: number
    offlineCount: number
    onlineCount: number
    ownerReadOnly: boolean
    partnerId: number
    partnerName: string
}
